import { buildLifeAreaTaskCustomOrder } from '@griply/utils';
import { useMemo } from 'react';
import { LifeArea } from 'shared/types/life-area';
import { TaskGroupBy } from 'shared/types/sorting-mode';

export const useLifeAreaCustomOrderByGrouping = (
  groupBy: TaskGroupBy | undefined | null,
  lifeArea?: LifeArea,
) =>
  useMemo(
    () => buildLifeAreaTaskCustomOrder(groupBy, lifeArea),
    [groupBy, lifeArea],
  );
